export { Confetti, type ConfettiProps, type ConfettiVariant } from "./Confetti"
